export var CONTENTS_PER_PAGE = 50; /* TODO */
